var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: { "no-backdrop-dismiss": "", "no-esc-dismiss": "" },
      on: {
        hide: function($event) {
          return _vm.hideModal()
        }
      },
      model: {
        value: _vm.show_change_password,
        callback: function($$v) {
          _vm.show_change_password = $$v
        },
        expression: "show_change_password"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              !_vm.user_change_password
                ? _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.hideModal()
                      }
                    }
                  })
                : _vm._e(),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("change_password")) +
                    "\n            "
                )
              ])
            ],
            1
          ),
          _c("div", { staticClass: "layout-padding" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("q-input", {
                    attrs: {
                      "float-label": _vm.$t("current_password"),
                      type: "password",
                      error: _vm.$v.current_password.$error
                    },
                    on: { input: _vm.$v.current_password.$touch },
                    model: {
                      value: _vm.current_password,
                      callback: function($$v) {
                        _vm.current_password = $$v
                      },
                      expression: "current_password"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "q-field",
                    {
                      attrs: {
                        helper: _vm.$t(_vm.getPasswordHelper),
                        error: _vm.$v.new_password.$error
                      }
                    },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("password"),
                          type: "password",
                          error: _vm.$v.new_password.$error
                        },
                        on: { input: _vm.$v.new_password.$touch },
                        model: {
                          value: _vm.new_password,
                          callback: function($$v) {
                            _vm.new_password = $$v
                          },
                          expression: "new_password"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("q-input", {
                    attrs: {
                      "float-label": _vm.$t("confirm_password"),
                      type: "password",
                      error: _vm.$v.confirm_password.$error
                    },
                    on: { input: _vm.$v.confirm_password.$touch },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.setNewPassword()
                      }
                    },
                    model: {
                      value: _vm.confirm_password,
                      callback: function($$v) {
                        _vm.confirm_password = $$v
                      },
                      expression: "confirm_password"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("q-btn", {
                    staticClass: "full-width q-mt-md",
                    attrs: {
                      color: "primary",
                      icon: "fas fa-key",
                      label: _vm.$t("set_new_password")
                    },
                    on: {
                      click: function($event) {
                        return _vm.setNewPassword()
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  !_vm.user_change_password
                    ? _c("q-btn", {
                        staticClass: "full-width q-mt-md",
                        attrs: {
                          color: "tertiary",
                          icon: "fas fa-times",
                          label: _vm.$t("cancel")
                        },
                        on: {
                          click: function($event) {
                            return _vm.hideModal()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          on: {
            ok: function($event) {
              return _vm.hideModal()
            }
          },
          model: {
            value: _vm.success,
            callback: function($$v) {
              _vm.success = $$v
            },
            expression: "success"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("change_password")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("new_password_set_success")))
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          model: {
            value: _vm.error,
            callback: function($$v) {
              _vm.error = $$v
            },
            expression: "error"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("error")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("current_password_is_incorrect")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }